import React from 'react';
import ResponsiveDrawer from '../../component/sidebar/sidebar.component';
import DashboardPage from './Dashboard.page';
import GlobalSearch from '../../component/sidebar/globalSearch';

const DashboardWrapper = () => {
  const handleSearch = (value) => {
    // placeholder; dashboard doesn't use search yet
    console.log('dashboard search', value);
  };

  return (
    <ResponsiveDrawer maincontent={<DashboardPage />} globalsearch={<GlobalSearch onSearch={handleSearch} />} />
  );
};

export default DashboardWrapper;
